// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__vJiEL","enColor":"Error_enColor__79gXX","ruColor":"Error_ruColor__NwneJ"};